/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function CategoriesList({ title, categories }) {
  const renderItems = categories.map(({ color, icon, name, description, route }, key) => (
    <Link key={key} to={route} style={{ textDecoration: 'none' }}> 
      <SoftBox
        key={name}
        component="li"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        borderRadius="lg"
        py={1}
        px={2}
        mb={categories.length - 1 === key ? 0 : 1}
        border="1px solid #E0E0E0"
        sx={{
          '&:hover': {
            backgroundColor: '#F5F5F5', // Light gray background on hover
          },
          cursor: 'pointer', // Change cursor to indicate clickable area
        }}
      >
        <SoftBox display="flex" alignItems="center">
          <SoftBox
            display="grid"
            alignItems="center"
            justifyContent="center"
            bgColor={color}
            borderRadius="lg"
            shadow="md"
            color="white"
            width="2rem"
            height="2rem"
            mr={2}
            variant="gradient"
          >
            <Icon
              sx={{
                display: "grid",
                placeItems: "center",
              }}
            >
              {icon}
            </Icon>
          </SoftBox>
          <SoftBox display="flex" flexDirection="column">
            <SoftTypography variant="h6" color={color} fontWeight="medium" >
              {name}
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              {description}
            </SoftTypography>
          </SoftBox>
        </SoftBox>
        <SoftBox display="flex" alignItems="center" justifyContent="flex-end" flexGrow={1}>
          <Icon sx={{ fontWeight: "bold", color: `${color} !important` }}>chevron_right</Icon>
        </SoftBox>
      </SoftBox>
    </Link>
  ));

  return (


      <SoftBox pb={2} pt={3} px={2} >
        <SoftBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
          {renderItems}
        </SoftBox>
      </SoftBox>

  );
}

// Typechecking props for the CategoriesList
CategoriesList.propTypes = {
  title: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default CategoriesList;
